import { Inject, Injectable, Injector } from '@angular/core';

import { Notifications_FlowService } from './Notifications.flow.index';
import { FootprintApiManager_FlowService } from './FootprintApiManager.flow.index';

import { app_import_sales_order_csv_from_sftpService } from './app.flow.index';

import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Notifications = this.injector.get(Notifications_FlowService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_FlowService);
  }

    public Notifications: Notifications_FlowService;
    public FootprintApiManager: FootprintApiManager_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _import_sales_order_csv_from_sftp: app_import_sales_order_csv_from_sftpService;
  public async import_sales_order_csv_from_sftp($inParams: {  }): Promise< { orderIds?: number[], messages?: any[] }> {
    if(!this._import_sales_order_csv_from_sftp) { 
      this._import_sales_order_csv_from_sftp = this.injector.get(app_import_sales_order_csv_from_sftpService);
    }
    return this._import_sales_order_csv_from_sftp.run($inParams);
  }
   
   

   
}
